import { render, staticRenderFns } from "./negotiate-offer.modal.vue?vue&type=template&id=28a7f878&scoped=true"
import script from "./negotiate-offer.modal.vue?vue&type=script&lang=js"
export * from "./negotiate-offer.modal.vue?vue&type=script&lang=js"
import style0 from "./negotiate-offer.modal.vue?vue&type=style&index=0&id=28a7f878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a7f878",
  null
  
)

export default component.exports